import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkUnlockSuperAdmin, ISuperAdminStore, ISuperAdminActions } from '../types';

const onUnlockSuperAdmin: IThunkUnlockSuperAdmin = thunk(
  async ({ setSuperAdmins }: Actions<ISuperAdminActions>, superAdminId, { getState }) => {
    const localState = getState() as ISuperAdminStore;
    await api.superAdmin.unlockSuperAdmin(superAdminId);

    const updatedList = localState.list.map(superAdmin =>
      superAdmin.id !== superAdminId ? superAdmin : { ...superAdmin, status: 'Active' },
    );

    setSuperAdmins({ items: updatedList });
  },
);

export default onUnlockSuperAdmin;
